export class Radiology {
    radiologyId: number;
    name: string;
    type: string;
    createdDate: Date;
    createdBy: number;
    modifiedBy?: number;
    modifiedDate?: Date;
    totalItems?: number;
} 